import Element from "./AddressSection";
import { useSelector } from "react-redux";
import { selectAuthConfigs } from "Store/auth/authSelectors";
import isEqual from "fast-deep-equal/es6";
import { useRef } from "react";

function AddressSection({ address, onClick }) {
  const { text, general, components } = useSelector(selectAuthConfigs, isEqual);
  const element = useRef();
  return (
    <Element
      ref={element}
      text={text}
      general={general}
      components={components}
      address={address}
      onClick={onClick}
    />
  );
}

export default AddressSection;
